<template>
    <div class="settings-menu">
        <div v-for="groupId in Object.keys(menuGroups)" :key="groupId" class="group-wrapper">
            <div
                class="group"
                :class="{
                    collapsed: isGroupCollapsed(groupId),
                    selected: isGroupSelected(groupId),
                }"
                @click="toggleGroup(groupId)"
            >
                <div class="left">
                    <span class="icon">
                        <HomeIcon v-if="groupId === 'General'" />
                        <ChatBubbleIcon v-if="groupId === 'Chat'" />
                        <TimeClockIcon v-if="groupId === 'Timings'" />
                        <IntegrationIcon v-if="groupId === 'Integration'" />
                    </span>
                    <span class="title">{{ $t(`settings.${groupId}`) }}</span>
                </div>
                <div class="right">
                    <IconButton :on-click="() => toggleGroup(groupId)" class="collapse-button">
                        <a-icon type="caret-down" v-if="!isGroupCollapsed(groupId)" @click="toggleGroup(groupId)" />
                        <a-icon type="caret-up" v-else @click="toggleGroup(groupId)" />
                    </IconButton>
                </div>
            </div>
            <div class="list" :class="{ hidden: !isGroupCollapsed(groupId) }">
                <div :key="item.id" v-for="item in menuGroups[groupId].filter((x) => !x.disabled)">
                    <div class="item" :class="{ selected: value === item.id }" @click="$emit('input', item.id)">
                        {{ $t(`settings.${item.id === "language" ? "languageTimeZone" : item.id}`) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SettingsMenuTypes from "./SettingsMenuTypes";
import IconButton from "./components/IconButton.vue";
import _ from "lodash";
import log2 from "../../../utils/log2";
import HomeIcon from "../../../components/svg/icons/HomeIcon.vue";
import ChatBubbleIcon from "../../../components/svg/icons/ChatBubbleIcon.vue";
import TimeClockIcon from "../../../components/svg/icons/TimeClockIcon.vue";
import IntegrationIcon from "../../../components/svg/icons/IntegrationIcon.vue";

const log = log2("SettingsMenu");
export default {
    name: "SettingsMenu",
    components: {
        IconButton,
        HomeIcon,
        ChatBubbleIcon,
        TimeClockIcon,
        IntegrationIcon,
    },
    props: {
        value: {
            type: String,
            default: "company",
        },
    },
    computed: {},
    data() {
        return {
            unCollapsedGroupIds: [],
            menuGroups: _.groupBy(SettingsMenuTypes, "group"),
        };
    },
    methods: {
        isGroupCollapsed(groupId) {
            return !this.unCollapsedGroupIds.includes(groupId);
        },
        isGroupSelected(groupId) {
            return this.menuGroups[groupId].some((item) => item.id === this.value);
        },
        toggleGroup(groupId) {
            if (this.isGroupCollapsed(groupId)) {
                this.unCollapsedGroupIds.push(groupId);
            } else {
                this.unCollapsedGroupIds = this.unCollapsedGroupIds.filter((id) => id !== groupId);
            }
        },
    },
};
</script>

<style scoped>
.dark-mode .settings-menu {
    background: #1e1e2d !important;
    border-radius: 0px 0 0 !important;
}

.dark-mode .item {
    color: #fff !important;
}
</style>
